import React from "react";
import { useNewLayout } from "store/selectors/hooks";

interface DetailPageLayoutProps {
    bgClass?: string;
    children?: React.ReactNode;
}

export const DetailPageLayout: React.FC<DetailPageLayoutProps> = props => {
    const { bgClass, children } = props;
    const newLayout = useNewLayout();
    if (newLayout) {
        return (
            <div className="px-4 pb-2 mb-2 bg-zinc-50 min-h-screen border-t border-t-gray-200">
                {children}
            </div>
        );
    }
    return <div className={`col main-body full-width ${bgClass}`}>{children}</div>;
};
